import { getCurrentInstance, inject } from 'vue';
import dayjs from 'dayjs';

import type { DateFormatProps} from '@/config/local/en';
import { USE_LOCALPROVIDER } from '@/config/local/en';

const useLocalProvider = () => {
  const vm = getCurrentInstance()?.proxy;

  if (!vm) {
    throw new Error(
      'vue-query hooks can only be used inside setup() function.',
    );
  }
  const local = inject<DateFormatProps>(USE_LOCALPROVIDER);
  if (!local) {
    throw new Error(
      "No apiClient found in Vue context, use 'useRightsProvider' to set one in the root component.",
    );
  }

  return {
    local,
    dateShort: (date: string) => dayjs(date).format(local.short),
    dateShortTime: (date: string) => dayjs(date).format(local.shortTime),
    dateShortTimeLocal: (date: string) => dayjs.utc(date, 'YYYY-MM-DD HH:mm:ss')
      .tz(dayjs.tz.guess())
      .format(local.shortTime)
    ,
  };
};

export default useLocalProvider;
